import { Fragment, useState, useEffect } from "react";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import { Modal, ModalBody, ModalFooter } from "reactstrap";
import ReactImageMagnify from "react-image-magnify";

function ModalRecord({ records }) {
    const [isOpen, setIsOpen] = useState(false);
    const { t } = useTranslation();
    const [data, setData] = useState([]);

    useEffect(() => {
        if (records?.length > 0) {
            setData(records);
            setIsOpen(true);
        }
    }, [records]);

    const onClose = () => {
        setData([])
        setIsOpen(false);
    };

    return (
        <Fragment>
            <Modal
                centered={true}
                // fullscreen={true}
                size="xl"
                toggle={() => {
                    onClose();
                }}
                isOpen={isOpen}
            >
                <div className="modal-header">
                    <h3>{t("View records")}</h3>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal">
                        <i
                            className="ki-outline ki-cross fs-1"
                            onClick={() => {
                                onClose();
                            }}
                        ></i>
                    </div>
                </div>
                <ModalBody>
                    {Array.isArray(data) && data.map((rec, idx) => (
                        <div key={idx} style={{ padding: '12px 0', borderBottom: '1px solid #eee' }}>
                            {/* NOTE */}
                            <p style={{ margin: '6px 0 10px', whiteSpace: 'pre-line' }}>
                                {rec.note || rec.description || ''}
                            </p>

                            {/* MEDIA ROW: ảnh + video cùng một hàng */}
                            {(rec?.images?.length || rec?.videos?.length) ? (
                                <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'flex-start' }}>
                                    {/* ẢNH */}
                                    {rec.images?.map((img, i) => (
                                        <ReactImageMagnify
                                            {...{
                                                smallImage: {
                                                    alt: "",
                                                    width: 160,
                                                    height: 160,
                                                    src: img.url || require("components/assets/media/misc/image.png"),
                                                },
                                                largeImage: {
                                                    src: img.url || require("components/assets/media/misc/image.png"),
                                                    width: 600,
                                                    height: 600,
                                                },
                                                enlargedImageContainerDimensions: { width: "200%", height: "200%" },
                                                enlargedImageContainerStyle: { zIndex: 999999 },
                                                className: "cursor-pointer",
                                                enlargedImageContainerClassName: "al-zoom-img-cus",
                                                imageStyle: { zIndex: 9999999 },
                                            }}
                                        />
                                    ))}

                                    {/* VIDEO */}
                                    {rec.videos?.map((v, j) => (
                                        <video
                                            key={`vid-${j}`}
                                            src={v.url}
                                            controls
                                            poster={v.cover}
                                            width={v.width || 200}
                                            height={v.height || 200}
                                            style={{ borderRadius: 8, outline: 'none' }}
                                        />
                                    ))}
                                </div>
                            ) : null}
                        </div>
                    ))}
                </ModalBody>

                <ModalFooter>
                    <button
                        type="reset"
                        id="kt_modal_users_search_reset"
                        data-bs-dismiss="modal"
                        className="btn btn-active-light me-3"
                        onClick={() => {
                            onClose();
                        }}
                    >
                        {t("Close")}
                    </button>
                </ModalFooter>
            </Modal>
        </Fragment>
    );
}

const mapStateToProps = (state) => ({});
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(ModalRecord);
